import {
  flatMap,
  fromBoolean,
  fromCondition,
  ifImmediate,
  pipe,
  succeed,
  sync,
  tapLeftAsync,
  tapMatchAsync,
  tapRightAsync,
  type Async,
  type Effect,
} from "@otto-ec/assets-core-utils/nano-effect";
import { tick } from "svelte";
import { sheetTagName } from "../utils/consts.js";
import { parseSheetHashParamIntoIdOrProps } from "./parameter.js";
import { scopeInfo, statePropOnLoad, statePropStack, type SheetNavScope } from "./scope.js";
import { navScope } from "./scope.js";
import type { OcSheetV1Props } from "../SheetV1.types.g.js";

const log = /*           */ navScope.scope("page-entry");
const logPrepare = /*           */ log.scope("prepare");

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const whenHashParamsContainSheetProps = (
  sheetIdOrProps: string | OcSheetV1Props,
): Effect<OcSheetV1Props, null> =>
  fromCondition(
    typeof sheetIdOrProps === "object" && !!sheetIdOrProps,
    sheetIdOrProps as OcSheetV1Props,
    null,
  );

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const insertIntermediateHistoryEntryForSheetOpen = async (
  scope: SheetNavScope,
): Promise<void> => {
  if (import.meta.env.DEV) logPrepare.info("prepare sheet open from hash parameters");

  const state = scope.state();
  const hash = scope.hash();

  /*                                                                                 */
  if (import.meta.env.DEV)
    logPrepare.info("ensure empty history entry for page entry", history.length);
  const params = hash.get(sheetTagName)!;
  hash.clear();
  state.clear();
  await scope.replace(scopeInfo);
  /*                                                                       */
  /*                                                      */
  if (import.meta.env.DEV)
    logPrepare.info("push new history entry with params", params, history.length);

  /*                                                                                 */
  /*                    */
  hash.set(sheetTagName, params);
  state.set(statePropOnLoad, true);
  await scope.push();
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const markExistingStateToBeOpened = async (scope: SheetNavScope): Promise<void> => {
  if (import.meta.env.DEV)
    logPrepare.info("state is not empty, mark as page entry load", history.length);

  scope.state().set(statePropOnLoad, true);
  await scope.replace();
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const rewindHistoryIfSheetShouldNotBeOpened = (scope: SheetNavScope): Promise<void> => {
  const state = scope.state();

  if (import.meta.env.DEV)
    logPrepare.info("cleanup sheet history state on reentry", history.length);
  if (state.empty) return tick();

  /*                                                                                             */
  /*                        */
  const stackLength = state.get(statePropStack)?.length ?? 0;
  const framesToPop = -1 - stackLength;

  if (import.meta.env.DEV) logPrepare.info("rewind history by", framesToPop, "entries");
  /*                                                                    */
  scope.go(framesToPop, scopeInfo);
  /*                                                                                     */
  /*                                        */
  return new Promise<void>((resolve) => {
    const controller = new AbortController();
    scope.current.sub((c) => {
      if (c.hash.has(sheetTagName)) return;
      resolve(controller.abort());
    }, controller);
  });
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const prepareOpenSheetOnPageEntry = (
  scope: SheetNavScope,
): Effect<void | OcSheetV1Props, null, Async> => {
  /*                                                                                 */
  /*                                                                                      */
  /*                                                    */

  if (import.meta.env.DEV) logPrepare.info("prepare sheet state for page entry", history.length);
  /*                                                         */
  return ifImmediate(scope.hash().has(sheetTagName), {
    /*                                      */
    onTrue: () =>
      pipe(
        succeed(scope.hash().get(sheetTagName)!),
        /*                                                               */
        parseSheetHashParamIntoIdOrProps,
        /*                                                                                     */
        flatMap(whenHashParamsContainSheetProps),

        tapMatchAsync({
          /*                                                                             */
          onSucceed: () =>
            pipe(
              /*                                                                       */
              fromBoolean(scope.state().empty),
              /*                                                                      */
              tapRightAsync(insertIntermediateHistoryEntryForSheetOpen.bind(null, scope)),
              /*                                                        */
              tapLeftAsync(markExistingStateToBeOpened.bind(null, scope)),
            ),

          /*                                                                                 */
          /*                                                 */
          onFail: rewindHistoryIfSheetShouldNotBeOpened.bind(null, scope),
        }),
      ),
    /*                                              */
    onFalse: sync(() => {
      if (import.meta.env.DEV)
        logPrepare.info("no sheet tag in hash, skip page entry handling", history.length);
    }),
  });
};
